import type { Translations } from './keys'

export const fi: Translations = {
  loading: "Ladataan...",
  error: "Virhe",
  success: "Onnistui",
  cancel: "Peruuta",
  delete: "Poista",
  save: "Tallenna",
  my_products: "Omat tuotteet",
  sign_out: "Kirjaudu ulos",
  skip: "Ohita",
  no_products: "Ei tuotteita vielä",
  tap_camera: "Paina kameraa lisätäksesi ensimmäisen tuotteen",
  delete_confirm: "Haluatko varmasti poistaa tämän tuotteen?",
  selling: "Myynti",
  my_lists: "Omat listat",
  account: "Tili",
  drafts: "Luonnokset",
  items_to_link: "tuotetta linkitettävänä",
  no_drafts: "Ei luonnoksia",
  my_reservations: "Omat varaukset",
  active_booths: "Näytä aktiiviset myyntipisteet",
  manage_stores: "Hallitse kauppojasi",
  favorites: "Suosikit",
  saved_items: "tallennettua tuotetta",
  no_favorites: "Ei suosikkeja vielä",
  favorites_hint: "Selaa tuotteita ja tallenna ne sydämellä tänne",
  profile: "Profiili",
  profile_settings: "Profiiliasetukset",
  edit_profile: "Muokkaa profiilia ja asetuksia",
  user: "Käyttäjä",
  public_profile: "Julkinen profiili",
  display_name: "Näyttönimi",
  display_name_placeholder: "Myyjänimesi",
  display_name_hint: "Tämä näkyy tuotteissasi",
  personal_info: "Henkilötiedot",
  first_name: "Etunimi",
  last_name: "Sukunimi",
  phone_placeholder: "+358 40 123 4567",
  preferences: "Asetukset",
  profile_updated: "Profiilisi on päivitetty",
  profile_update_failed: "Profiilin päivitys epäonnistui",
  draft_products_info: "Nämä tuotteet eivät ole vielä linkitetty myyntipisteeseen. Paina pitkään valitaksesi useita.",
  create_products_hint: "Ota kuvia tuotteista jotka haluat myydä",
  delete_products: "Poista tuotteet",
  delete_products_confirm: "Haluatko varmasti poistaa valitut tuotteet?",
  link_to_booth: "Linkitä pisteeseen",
  select_all_items: "Valitse kaikki",
  deselect_all_items: "Poista valinnat",
  single_item: "tuote",
  browse_products: "Selaa tuotteita",
  ai_label: "AI-tunnistus",
  captured: "Otettu",
  uploading: "ladataan",
  camera_permission: "Kameran käyttöoikeus vaaditaan tuotteiden lisäämiseen",
  grant_permission: "Anna lupa",
  camera: "Kamera",
  gallery: "Galleria",
  barcode: "Viivakoodi",
  status: "Tila",
  title_optional: "Otsikko (valinnainen)",
  enter_title: "Syötä tuotteen otsikko",
  description_optional: "Kuvaus (valinnainen)",
  enter_description: "Syötä tuotteen kuvaus",
  price_required: "Hinta (€) *",
  approve_publish: "Hyväksy ja julkaise",
  save_draft: "Tallenna luonnoksena",
  delete_product: "Poista tuote",
  ai_suggest: "AI-ehdotus",
  product_published: "Tuote julkaistu!",
  draft_saved: "Luonnos tallennettu!",
  valid_price_required: "Syötä kelvollinen hinta",
  no_image_for_ai: "Ei kuvaa AI-analyysia varten",
  ai_failed: "AI-ehdotusten haku epäonnistui. Yritä uudelleen.",
  draft: "luonnos",
  for_sale: "myynnissä",
  sold: "myyty",
  reserved: "varattu",
  returned: "palautettu",
  sign_in_email: "Kirjaudu sähköpostilla",
  sign_in_google: "Kirjaudu Googlella",
  email: "Sähköposti",
  password: "Salasana",
  language: "Kieli",
  english: "Englanti",
  finnish: "Suomi",
  markets: "Kirpputorit",
  flea_markets: "Kirpputorit",
  my_markets: "Omat kirpputorit",
  join_market: "Liity kirpputorille",
  create_market: "Luo kirpputori",
  enter_invite_code: "Syötä kutsukoodi",
  join: "Liity",
  joining: "Liitytään...",
  invalid_code: "Virheellinen kutsukoodi",
  already_member: "Olet jo tämän kirpputorin jäsen",
  joined_market: "Liityttiin kirpputorille!",
  market_name: "Kirpputorin nimi",
  market_description: "Kuvaus (valinnainen)",
  market_address: "Osoite (valinnainen)",
  commission_rate: "Provisio (%)",
  creating: "Luodaan...",
  create: "Luo",
  market_created: "Kirpputori luotu!",
  back: "Takaisin",
  sellers: "Myyjät",
  active_sellers: "Aktiiviset myyjät",
  pending_requests: "Odottavat pyynnöt",
  products_for_sale: "Tuotteita myynnissä",
  total_sales: "Kokonaismyynti",
  invite_code: "Kutsukoodi",
  manage_sellers: "Hallitse myyjiä",
  edit_settings: "Muokkaa asetuksia",
  no_markets: "Et ole vielä minkään kirpputorin jäsen",
  pending: "odottaa",
  approved: "hyväksytty",
  rejected: "hylätty",
  suspended: "keskeytetty",
  all: "Kaikki",
  confirm: "Vahvista",
  confirm_approve: "Hyväksy tämä myyjä?",
  confirm_reject: "Hylkää tämä myyjä?",
  approve: "Hyväksy",
  reject: "Hylkää",
  seller_approved: "Myyjä hyväksytty!",
  seller_rejected: "Myyjä hylätty",
  update_failed: "Päivitys epäonnistui",
  suspend: "Keskeytä",
  reactivate: "Aktivoi uudelleen",
  no_pending_sellers: "Ei odottavia pyyntöjä",
  no_sellers: "Ei myyjiä varauksilla vielä",
  no_active_sellers: "Ei aktiivisia myyjiä",
  joined: "Liittyi",
  reservations_count: "varausta",
  active: "Aktiiviset",
  past: "Menneet",
  view_products: "Näytä tuotteet",
  confirm_cancel_reservation: "Peruuta tämä varaus?",
  reservation_cancelled: "Varaus peruttu",
  cancel_failed: "Peruutus epäonnistui",
  yes: "Kyllä",
  no: "Ei",
  edit_commission: "Muokkaa provisiota",
  commission_percentage: "Provisio %",
  commission_updated: "Provisio päivitetty!",
  commission_hint: "Kaupan osuus välitysmyyntien tuotoista",
  delete_store: "Poista kauppa",
  delete_store_confirm: "Haluatko varmasti poistaa tämän kaupan? Kaikki tuotteet poistetaan myös.",
  store_updated: "Kauppa päivitetty!",
  store_deleted: "Kauppa poistettu",
  spaces: "Myyntipaikat",
  manage_spaces: "Hallitse myyntipaikkoja",
  add_space: "Lisää paikka",
  edit_space: "Muokkaa paikkaa",
  no_spaces: "Ei myyntipaikkoja. Lisää ensimmäinen koju tai teline!",
  space_created: "Paikka luotu!",
  space_updated: "Paikka päivitetty!",
  confirm_delete_space: "Poista tämä paikka?",
  available: "vapaa",
  occupied: "käytössä",
  maintenance: "huollossa",
  space_type_booth: "Koju",
  space_type_rack: "Teline",
  space_type_table: "Pöytä",
  space_type_shelf: "Hylly",
  space_type_corner: "Nurkkaus",
  space_type_other: "Muu",
  location: "Sijainti",
  zone: "Alue",
  row: "Rivi",
  number: "Numero",
  dimensions_cm: "Mitat (cm)",
  width: "Leveys",
  depth: "Syvyys",
  height: "Korkeus",
  pricing: "Hinnoittelu",
  per_day: "Päivä",
  per_week: "Viikko",
  per_month: "Kuukausi",
  features: "Ominaisuudet",
  electricity: "Sähkö",
  lighting: "Valaistus",
  accessible: "Esteetön",
  name: "Nimi",
  type: "Tyyppi",
  description: "Kuvaus",
  optional: "Valinnainen",
  add: "Lisää",
  duplicate: "Kopioi",
  space_duplicated: "Paikka kopioitu!",
  my_managed_markets: "Hallinnoimani kirpputorit",
  my_memberships: "Jäsenyyteni",
  available_markets: "Saatavilla olevat kirpputorit",
  no_markets_available: "Ei kirpputoreja saatavilla alueellasi vielä",
  spaces_available: "paikkaa vapaana",
  apply: "Hae",
  application_sent: "Hakemus lähetetty! Odota hyväksyntää.",
  apply_failed: "Hakemuksen lähetys epäonnistui",
  floor_plan: "Pohjapiirros",
  floor_plan_editor: "Pohjapiirroseditori",
  add_floor: "Lisää kerros",
  floor_name: "Kerroksen nimi",
  floor_name_placeholder: "esim. Pääsali, Kerros 1",
  dimensions: "Mitat",
  floor_dimensions: "Lattia-alueen mitat",
  width_m: "Leveys (m)",
  depth_m: "Syvyys (m)",
  dimensions_hint: "1000cm = 10 metriä. Oletus on 10m × 8m.",
  floor_dimensions_hint_m: "Syötä todellisen lattia-alueen mitat metreinä.",
  confirm_delete_floor: "Haluatko varmasti poistaa tämän kerroksen? Kaikki paikat tällä kerroksella poistetaan myös.",
  save_changes: "Tallenna muutokset",
  overlap_error: "Ei voi sijoittaa tähän",
  overlap_message: "Tämä sijainti on päällekkäin toisen pöydän kanssa. Valitse toinen sijainti.",
  fit: "Sovita",
  create_floor: "Luo kerros",
  no_floor_selected: "Kerrosta ei valittu",
  add_spot_type: "Lisää paikkatyyppi",
  type_name: "Tyypin nimi",
  type_name_placeholder: "esim. Pieni pöytä, Iso koju",
  color: "Väri",
  create_type: "Luo tyyppi",
  new_type: "Uusi tyyppi",
  enter_floor_name: "Anna kerroksen nimi",
  enter_spot_type_name: "Anna nimi",
  enter_at_least_one_price: "Anna vähintään yksi hinta",
  select_floor_and_type: "Valitse ensin kerros ja paikkatyyppi",
  spots: "Paikat",
  types: "Tyypit",
  delete_spot: "Poista paikka",
  confirm_delete_spot: "Haluatko varmasti poistaa tämän paikan?",
  position: "Sijainti",
  rotation: "Kierto",
  rotate: "Kierrä",
  create_floor_hint: "Luo kerros aloittaaksesi pohjapiirroksen suunnittelun",
  add_table_type: "Lisää pöytätyyppi",
  new_table: "Uusi pöytä",
  presets: "Pikapohjamallit",
  custom: "Mukautettu",
  create_and_add: "Luo ja lisää",
  copied: "Kopioitu",
  click_to_paste: "Klikkaa pohjapiirrosta liittääksesi",
  pasting: "Liitetään",
  prefix: "Etuliite",
  start: "Aloitus",
  next: "Seuraava",
  copy: "Kopioi",
  select_space: "Valitse paikka",
  no_floor_plan: "Pohjapiirros ei ole saatavilla tälle kirpputorille",
  no_spots_on_floor: "Ei paikkoja tällä kerroksella",
  show_available_only: "Vain vapaat",
  tap_spot_to_reserve: "Napauta vapaata paikkaa varataksesi sen",
  loading_availability: "Ladataan saatavuutta...",
  your_selection: "Valintasi",
  reservation_created: "Paikka varattu onnistuneesti!",
  login_to_reserve: "Kirjaudu sisään tehdäksesi varauksen",
  spot_details: "Paikan tiedot",
  map_view: "Karttanäkymä",
  list_view: "Listanäkymä",
  floor: "Kerros",
  spot: "Paikka",
  spot_number: "Paikan numero",
  edit_floor: "Muokkaa kerrosta",
  delete_floor: "Poista kerros",
  floor_deleted: "Kerros poistettu",
  spot_type: "Paikkatyyppi",
  edit_spot_type: "Muokkaa paikkatyyppiä",
  delete_spot_type: "Poista paikkatyyppi",
  spot_type_deleted: "Paikkatyyppi poistettu",
  spot_added: "Paikka lisätty",
  spot_updated: "Paikka päivitetty",
  spot_deleted: "Paikka poistettu",
  click_to_add_spot: "Klikkaa kanvaasille lisätäksesi paikan",
  drag_to_move: "Vedä paikkoja siirtääksesi niitä",
  select_mode: "Valintatila",
  add_mode: "Lisäystila",
  no_spots_created: "Paikkoja ei ole vielä luotu",
  create_spots_hint: "Käytä pohjapiirrosmuokkuria lisätäksesi pöytiä markkinoillesi",
  open_floor_plan: "Avaa pohjapiirrosmuokkuri",
  edit_spot: "Muokkaa paikkaa",
  is_active: "Aktiivinen",
  is_available: "Varattavissa",
  notes: "Muistiinpanot",
  notes_placeholder: "Lisää muistiinpanoja tästä paikasta...",
  current_reservation: "Nykyinen varaus",
  no_pricing: "Hintaa ei asetettu",
  price_per_day: "Hinta per päivä",
  price_per_week: "Hinta per viikko",
  price_per_month: "Hinta per kuukausi",
  edit_dimensions_hint: "Mittoja voi muuttaa pohjapiirrosmuokkurissa",
  unavailable: "Ei saatavilla",
  reservations: "Varaukset",
  view_reservations: "Näytä varaukset",
  no_reservations: "Ei varauksia vielä",
  confirm_reservation: "Vahvista varaus",
  cancel_reservation: "Peruuta tämä varaus?",
  cancel_action: "Peruuta se",
  decline: "Hylkää",
  mark_completed: "Merkitse valmiiksi",
  status_updated: "Tila päivitetty!",
  confirmed: "vahvistettu",
  cancelled: "peruutettu",
  completed: "valmis",
  unpaid: "maksamaton",
  partial: "osittain",
  paid: "maksettu",
  refunded: "palautettu",
  browse: "Selaa",
  sell: "Myy",
  find_market_book_table: "Löydä kirpputori ja varaa pöytä",
  search_products: "Etsi tuotteita...",
  all_markets: "Kaikki kirpputorit",
  no_results: "Ei tuloksia",
  no_products_available: "Ei tuotteita saatavilla vielä",
  untitled: "Nimetön",
  listed: "Lisätty",
  product_not_found: "Tuotetta ei löydy",
  go_back: "Takaisin",
  tap_for_directions: "Napauta reittiohjeet",
  seller: "Myyjä",
  product_code: "Tuotekoodi",
  edit_product: "Muokkaa tuotetta",
  available_spaces: "Vapaat myyntipaikat",
  no_available_spaces: "Ei vapaita paikkoja tällä hetkellä",
  tap_to_reserve: "Napauta varataksesi",
  reserve_space: "Varaa paikka",
  start_date: "Alkamispäivä",
  end_date: "Päättymispäivä",
  total_price: "Kokonaishinta",
  submit_reservation: "Lähetä varauspyyntö",
  reservation_submitted: "Varaus lähetetty",
  reservation_failed: "Varauksen lähetys epäonnistui",
  space_already_reserved: "Tämä paikka on jo varattu noille päiville",
  invalid_dates: "Virheelliset päivämäärät",
  reservation_note: "Kirpputorin ylläpitäjä tarkistaa varauksesi.",
  browse_spaces: "Varaa paikka",
  reserve_spot: "Varaa paikka",
  spot_unavailable: "Paikka ei saatavilla",
  spot_unavailable_message: "Tämä paikka ei ole tällä hetkellä varattavissa.",
  reservation_submitted_message: "Varauspyyntösi on lähetetty. Kirpputorin ylläpitäjä tarkistaa ja vahvistaa sen.",
  proceed_to_reserve: "Jatka varaukseen",
  contact_for_pricing: "Ota yhteyttä hintatietojen saamiseksi",
  select_duration: "Valitse kesto",
  spot_rental: "Paikkavuokra",
  commission_on_sales: "Provisio myynnistä",
  total_to_pay: "Maksettava yhteensä",
  reservation_confirmed_message: "Paikkasi on varattu. Voit nyt lisätä tuotteita myyntiin.",
  commission: "provisio",
  select: "Valitse",
  duration: "Kesto",
  day: "päivä",
  days: "päivää",
  week: "viikko",
  month: "kuukausi",
  later: "Myöhemmin",
  add_products: "Lisää tuotteita",
  no_reservations_home: "Ei varauksia",
  reserve_space_first: "Varaa paikka kirpputorilta aloittaaksesi myymisen",
  browse_markets: "Selaa kirpputoreja",
  take_photos: "Kuvaa tuotteita",
  from_gallery: "Lisää galleriasta",
  link_products: "Linkitä tuotteita",
  manage: "Hallitse",
  linked_products: "Linkitetyt tuotteet",
  no_products_yet: "Ei tuotteita vielä",
  add_products_hint: "Käytä yllä olevia painikkeita lisätäksesi tuotteita",
  select_products_to_link: "Valitse tuotteet linkitettäväksi tähän varaukseen",
  no_products_to_link: "Ei tuotteita linkitettäväksi",
  add_products_first: "Lisää tuotteita ensin kameralla tai galleriasta",
  reservation_confirmed: "Paikka varattu! Haluatko lisätä tuotteita nyt?",
  reservation_instant_note: "Varauksesi vahvistetaan heti. Maksu voidaan suorittaa myöhemmin.",
  reserve_now: "Varaa nyt",
  coming_soon: "Tulossa pian",
  reservation_not_found: "Varausta ei löydy. Päivitetään tietoja...",
  link_error: "Tuotteiden linkitys epäonnistui. Yritä uudelleen.",
  analyzing: "Analysoidaan",
  images_count: "kuvaa",
  upcoming_sales: "Tulevat myynnit",
  upcoming: "Tulossa",
  now_on: "Nyt käynnissä!",
  no_upcoming_sales: "Ei tulevia myyntejä tällä hetkellä",
  check_back_soon: "Tule takaisin pian uusien tuotteiden äärelle!",
  bulk_upload: "Massalisäys",
  default_price: "Oletushinta",
  apply_all: "Käytä kaikille",
  add_images: "Lisää kuvia",
  no_images_selected: "Ei kuvia valittu",
  tap_add_images: "Paina \"Lisää kuvia\" valitaksesi kuvia",
  upload_all: "Lataa kaikki",
  uploaded: "ladattu",
  uploaded_count: "Ladattu",
  title: "Otsikko",
  selected: "valittu",
  items_copied: "kopioitu",
  click_to_paste_items: "klikkaa liittääksesi",
  select_all: "Kaikki",
  link: "Linkitä",
  products: "tuotetta",
  linked_count: "Linkitetty",
  no_confirmed_reservations: "Tarvitset vahvistetun varauksen linkittääksesi tuotteita.",
  bulk_link_prompt: "Linkitä",
  to: "kohteeseen",
  enter_number: "Syötä numero",
  stores: "Kaupat",
  my_stores: "Omat kaupat",
  store: "Kauppa",
  no_stores: "Ei kauppoja vielä",
  create_store: "Luo kauppa",
  create_store_hint: "Luo oma käytetyn tavaran kauppa ja hallitse varastoa suoraan",
  add_store: "Lisää kauppa",
  inventory: "Varasto",
  store_owned: "Kaupan oma",
  consignment: "Välitys",
  consign: "Välitys",
  total: "Yhteensä",
  status_active: "Aktiivinen",
  inactive: "Ei aktiivinen",
  add_product_hint: "Paina kameraa lisätäksesi tuotteita",
  store_name: "Kaupan nimi",
  store_name_placeholder: "esim. Vintage Aarteet Helsinki",
  store_type: "Kaupan tyyppi",
  city: "Kaupunki",
  city_placeholder: "esim. Helsinki",
  store_description_placeholder: "Kuvaile kauppaasi...",
  enter_store_name: "Syötä kaupan nimi",
  login_required: "Sinun täytyy kirjautua sisään",
  store_created: "Kauppa luotu onnistuneesti!",
  consignment_info: "Välitysliike",
  consignment_hint: "Voit vastaanottaa tuotteita myyjiltä ja jakaa tuoton. Oletusprovisio on 30%.",
  suppliers: "Toimittajat",
  add_supplier: "Lisää toimittaja",
  edit_supplier: "Muokkaa toimittajaa",
  supplier_name: "Toimittajan nimi",
  supplier_name_placeholder: "esim. ABC Tukkukauppa",
  contact_name: "Yhteyshenkilö",
  contact_name_placeholder: "esim. Matti Meikäläinen",
  no_suppliers: "Ei toimittajia vielä",
  add_supplier_hint: "Lisää toimittajia seurataksesi tuotteiden alkuperää",
  supplier_created: "Toimittaja luotu!",
  supplier_updated: "Toimittaja päivitetty!",
  delete_supplier: "Poista toimittaja",
  confirm_delete_supplier: "Haluatko varmasti poistaa tämän toimittajan?",
  supplier_has_products: "Toimittajaa ei voi poistaa, sillä tuotteita on linkitetty",
  street_address: "Katuosoite",
  business_info: "Yritystiedot",
  business_id: "Y-tunnus",
  payment_terms: "Maksuehdot",
  inventory_reports: "Varastoraportit",
  overview: "Yleiskatsaus",
  low_stock: "Vähissä",
  movements: "Liikkeet",
  total_units: "Yksiköitä yhteensä",
  units_for_sale: "Myynnissä",
  inventory_value: "Varaston arvo",
  cost_value: "Hankinta-arvo",
  retail_value: "Myyntiarvo",
  potential_profit: "Potentiaalinen tuotto",
  low_stock_alert: "Varastovaroitus",
  products_need_restocking: "tuotetta täydennettävänä",
  top_selling: "Myydyimmät",
  no_low_stock: "Ei vähissä olevia tuotteita",
  all_items_stocked: "Kaikki tuotteet hyvin varastossa",
  threshold: "Raja",
  cost: "Hinta",
  no_movements: "Ei varastoliikkeitä",
  movements_will_appear: "Varastoliikkeet näkyvät täällä",
  stock_quantity: "Varastomäärä",
  sku: "Tuotekoodi",
  supplier: "Toimittaja",
  reorder_quantity: "Tilausmäärä",
  low_stock_threshold: "Varastohälytys",
  self_service_flea_market: "Itsepalvelukirpputori",
  self_service_flea_market_desc: "Myyjät hoitavat omat tuotteensa ja myyntinsä",
  full_service_flea_market: "Täyden palvelun kirpputori",
  full_service_flea_market_desc: "Henkilökunta hoitaa myynnin myyjien puolesta",
  consignment_store: "Välitysliike",
  consignment_store_desc: "Vastaanota tuotteita myyjiltä ja jaa tuotto",
  retail_store: "Käytetyn tavaran kauppa",
  retail_store_desc: "Vain kaupan oma varasto",
  antique_shop: "Antiikkiliike",
  vintage_store: "Vintage-kauppa",
  thrift_store: "Kirpputorikauppa",
  flea_market: "Kirpputori",
  select_store_type: "Millaisen kaupan luot?",
  flea_market_type: "Kirpputorin tyyppi",
  select_flea_market_type: "Millaisen kirpputorin luot?",
  change: "Vaihda",
  commission_rate_label: "Provisio (%)",
  commission_rate_hint: "Osuutesi jokaisesta myynnistä",
  space_rental: "Paikkavuokraus",
  space_rental_hint: "Myyjät vuokraavat paikkoja ja hoitavat omat myyntinsä",
  accepts_consignment: "Vastaanota myyntitarjouksia",
  accepts_consignment_hint: "Salli myyjien tarjota tuotteita myyntiin alustan kautta",
  default_commission: "Oletusprovisio",
  retail_store_hint: "Kaikki tuotteet ovat kaupan omia. Sopii ostamiseen ja edelleenmyyntiin.",
  selling_model: "Myyntimalli",
  selling_model_hint: "Miten myyjät osallistuvat kirpputoriisi?",
  booth_based: "Myyntipaikat",
  booth_based_desc: "Myyjät saavat oman paikan tuotteidensa esittelyyn",
  inventory_based: "Yhteinen myyntitila",
  inventory_based_desc: "Tuotteet ovat yhteisessä näytteillepanossa, jota sinä hallinnoit",
  consignment_period: "Välitysaika",
  consignment_period_hint: "Kuinka kauan tuotteet ovat myynnissä ennen palautusta myyjälle",
  payout_schedule: "Maksatusaikataulu",
  payout_schedule_hint: "Kuinka usein myyjät saavat ansionsa",
  per_sale: "Myynnistä",
  weekly: "Viikoittain",
  monthly: "Kuukausittain",
  commission_breakdown: "Provisioerittely",
  platform_provision: "Alustamaksu",
  platform_provision_hint: "Kattaa maksuliikenteen ja alustakulut",
  market_commission: "Sinun provisiosi",
  market_commission_hint: "Osuutesi jokaisesta myynnistä",
  total_provision: "Yhteensä",
  total_provision_hint: "Myyjän ansioista pidätetään yhteensä",
  basic_info_hint: "Kerro meille kaupastasi",
  street_address_placeholder: "esim. Mannerheimintie 1",
  business_settings: "Liiketoiminta-asetukset",
  business_settings_hint: "Määritä hinnoittelu ja maksutavat",
  payment_methods: "Maksutavat",
  payment_methods_hint: "Valitse hyväksytyt maksutavat",
  cash: "Käteinen",
  card: "Kortti",
  bank_transfer: "Tilisiirto",
  operations: "Toiminta",
  operations_hint: "Miten kauppasi toimii?",
  event_based: "Tapahtumapohjainen",
  event_based_hint: "Tämä on kertaluonteinen tai toistuva tapahtuma, ei pysyvä sijainti",
  space_rental_setup_hint: "Voit määrittää paikat ja hinnoittelun kirpputorin luomisen jälkeen",
  accepted_categories: "Hyväksytyt kategoriat",
  accepted_categories_hint: "Millaisia tuotteita hyväksyt?",
  min_item_value: "Tuotteen minimiarvo",
  min_item_value_hint: "Hyväksyttävien tuotteiden minimiarvo (0 = ei rajaa)",
  seller_terms: "Myyjien ehdot",
  seller_terms_placeholder: "Kirjoita myyjien ehdot ja säännöt...",
  seller_terms_hint: "Säännöt ja ehdot, joihin myyjien tulee sitoutua",
  review: "Tarkista",
  review_hint: "Tarkista kauppasi tiedot ennen luomista",
  continue: "Jatka",
  clothing: "Vaatteet",
  furniture: "Huonekalut",
  electronics: "Elektroniikka",
  books: "Kirjat",
  toys: "Lelut",
  sports: "Urheilu",
  home_decor: "Sisustus",
  antiques: "Antiikki",
  jewelry: "Korut",
  other: "Muut",
  management: "Hallinta",
  spaces_hint: "Pöydät, kojut ja telineet",
  sellers_hint: "Hyväksy ja hallitse myyjiä",
  pending_applications: "odottavaa hakemusta",
  reservations_hint: "Paikkavaraukset ja aikataulut",
  settings: "Asetukset",
  market_info: "Kirpputorin tiedot",
  edit: "Muokkaa",
  market_not_found: "Kirpputoria ei löydy",
  code_copied: "Kutsukoodi kopioitu!",
  invalid_commission: "Provision täytyy olla välillä 0-100",
  space_name: "Paikan nimi",
  space_name_placeholder: "esim. Pöytä A1",
  add_new_space: "Lisää uusi paikka",
  market_name_placeholder: "esim. Sunnuntain kirpputori",
  market_description_placeholder: "Kuvaile kirpputoriasi...",
  delete_market: "Poista kirpputori",
  delete_market_confirm: "Haluatko varmasti poistaa tämän kirpputorin? Kaikki paikat, varaukset ja tuotteet poistetaan myös.",
  market_deleted: "Kirpputori poistettu",
  seller_app: "Myyjäsovellus",
  sign_in: "Kirjaudu",
  sign_up: "Rekisteröidy",
  login_as_merchant: "Kirjaudu kauppiaana",
  continue_with_google: "Jatka Googlella",
  sign_in_with_email: "Kirjaudu sähköpostilla",
  already_have_account: "Onko sinulla jo tili? Kirjaudu",
  no_account: "Ei tiliä? Rekisteröidy",
  or: "tai",
  merchant_login: "Kauppiaan kirjautuminen",
  for_store_owners: "Kauppiaille",
  merchant: "Kauppias",
  merchant_portal: "Kauppiasportaali",
  merchant_portal_desc: "Hallitse kauppaasi ja varastoa",
  enter_email_password: "Syötä sähköposti ja salasana",
  check_email: "Tarkista sähköpostisi vahvistuslinkkiä varten",
  select_store: "Valitse kauppa",
  select_store_to_manage: "Valitse hallinnoitava kauppa",
  create_new_store: "Luo uusi kauppa",
  create_first_store: "Luo ensimmäinen kauppasi aloittaaksesi",
  dashboard: "Hallintapaneeli",
  total_products: "Tuotteita yhteensä",
  active_products: "Aktiivisia tuotteita",
  sold_today: "Myyty tänään",
  revenue_today: "Tuotto tänään",
  quick_actions: "Pikatoiminnot",
  view_inventory: "Näytä varasto",
  store_settings: "Kaupan asetukset",
  manage_staff: "Hallinnoi henkilökuntaa",
  switch_store: "Vaihda kauppaa",
  logout: "Kirjaudu ulos",
  search: "Haku",
  home: "Koti",
  pos: "Kassa",
  activity: "Toiminta",
  more: "Lisää",
  point_of_sale: "Kassa",
  scan_or_search: "Skannaa viivakoodi tai hae tuotteita...",
  ready_to_scan: "Valmis skannaamaan",
  scan_barcode_hint: "Skannaa viivakoodi tai kirjoita etsiäksesi tuotteita",
  cart: "Ostoskori",
  cart_empty: "Ostoskori on tyhjä",
  cash_received: "Saatu käteinen",
  complete_sale: "Viimeistele myynti",
  sale_completed: "Myynti valmis!",
  quick_sale: "Kassa",
  quick_sale_desc: "Aloita uusi myynti",
  add_product_desc: "Kamera tai galleria",
  kassa: "Kassa",
  take_photo_desc: "Ota kuva",
  pick_from_gallery_desc: "Valitse galleriasta",
  reports_desc: "Näytä analytiikka",
  recent_sales: "Viimeisimmät myynnit",
  view_all: "Näytä kaikki",
  low_in_stock: "vähissä",
  pending_offers: "Odottavat tarjoukset",
  offers_to_review: "tarjousta tarkasteltavana",
  no_sales_yet: "Ei myyntejä vielä",
  sales_will_appear_here: "Myynnit näkyvät täällä",
  offers_will_appear_here: "Saapuvat tarjoukset näkyvät täällä",
  no_payouts_yet: "Ei maksuja vielä",
  payouts_will_appear_here: "Myyjämaksut näkyvät täällä",
  store_management: "Kaupan hallinta",
  store_settings_desc: "Nimi, aukioloajat, yhteystiedot",
  staff_management: "Henkilökunnan hallinta",
  staff_desc: "Hallinnoi tiimin jäseniä ja rooleja",
  categories_desc: "Järjestä tuotteesi",
  inventory_orders: "Varasto & tilaukset",
  suppliers_desc: "Hallinnoi toimittajiasi",
  purchase_orders_desc: "Seuraa saapuvaa varastoa",
  stock_adjustment_desc: "Inventaariot, vauriot, palautukset",
  reports_analytics: "Raportit & analytiikka",
  reports_desc_full: "Myynti- ja varastoanalytiikka",
  switch_store_desc: "Hallinnoi toista kauppaa",
  help_support: "Ohje & tuki",
  help_desc: "Saa apua ja tukea",
  logout_desc: "Kirjaudu ulos tililtäsi",
  basic_info: "Perustiedot",
  images: "Kuvat",
  opening_hours: "Aukioloajat",
  contact: "Yhteystiedot",
  amenities: "Palvelut",
  opening_hours_desc: "Aseta kaupan aukioloajat jokaiselle viikonpäivälle",
  amenities_desc: "Valitse kaupassa tarjolla olevat palvelut",
  accepts_offers: "Saapuvat tarjoukset",
  accepts_offers_desc: "Salli myyjien lähettää tuotetarjouksia kauppaan",
  store_logo: "Kaupan logo",
  cover_image: "Kansikuva",
  tap_to_upload: "Napauta ladataksesi",
  logo_hint: "Suositeltu neliökuva (1:1)",
  cover_hint: "Suositeltu leveä kuva (16:9)",
  address_street: "Katuosoite",
  address_street_placeholder: "esim. Mannerheimintie 10",
  postal_code: "Postinumero",
  phone: "Puhelin",
  website: "Verkkosivut",
  closed: "Suljettu",
  monday: "Maanantai",
  tuesday: "Tiistai",
  wednesday: "Keskiviikko",
  thursday: "Torstai",
  friday: "Perjantai",
  saturday: "Lauantai",
  sunday: "Sunnuntai",
  parking: "Pysäköinti",
  wheelchair_accessible: "Esteetön",
  free_wifi: "Ilmainen WiFi",
  fitting_room: "Sovituskoppi",
  cafe: "Kahvila",
  card_payment: "Korttimaksu",
  cash_payment: "Käteismaksu",
  customer_email: "Asiakkaan sähköposti",
  customer_hint: "Tunnista asiakas digitaalista kuittia varten",
  customer_optional: "Asiakas (valinnainen)",
  customer_shows_qr: "Asiakas näyttää QR-koodin Fliisi-sovelluksesta",
  mobilepay: "MobilePay",
  search_settings: "Hakuasetukset",
  product_type: "Tuotetyyppi",
  flea_market_products: "Kirpputorituotteet",
  store_products: "Kauppatuotteet",
  upcoming_only: "Vain tulevat",
  price_range: "Hintahaarukka",
  sort_by: "Järjestys",
  newest: "Uusimmat",
  oldest: "Vanhimmat",
  ownership: "Omistajuus",
  price_asc: "Hinta ↑",
  price_desc: "Hinta ↓",
  price_low_to_high: "Halvin ensin",
  price_high_to_low: "Kallein ensin",
  reset: "Tyhjennä",
  payouts: "Maksut",
  seller_payouts: "Myyjätilitykset",
  payout_summary: "Tilitysyhteenveto",
  stripe_balance: "Stripe-saldo",
  insufficient_funds: "Riittämätön saldo.",
  top_up_needed: "Täydennystä tarvitaan:",
  top_up: "Täydennä saldoa",
  items_sold: "Tuotteita myyty",
  gross_sales: "Bruttomyynti",
  to_pay_sellers: "Myyjille maksettava",
  ready: "Valmis",
  need_setup: "vaatii asennuksen",
  pending_payouts: "Odottavat tilitykset",
  no_pending_payouts: "Ei odottavia tilityksiä",
  payouts_appear_here: "Tilitykset näkyvät täällä kun tuotteita myydään",
  no_stripe: "Ei Stripea",
  gross: "Brutto",
  net_payout: "Nettotilitys",
  no_payout_history: "Ei tilityshistoriaa",
  history_appear_here: "Käsitellyt tilitykset näkyvät täällä",
  net_paid: "Nettomaksu",
  top_up_to_process: "Täydennä käsitelläksesi",
  process_payouts: "Käsittele tilitykset",
  confirm_payouts: "Vahvista tilitykset",
  process: "Käsittele",
  history: "Historia",
  items: "Tuotteet",
  item_count_singular: "tuote",
  items_count_plural: "tuotetta",
  payout_history: "Tilityshistoria",
  received: "Saatu",
  payout_setup: "Tilitysasetukset",
  bank_account_connected: "Pankkitili yhdistetty",
  payout_ready_desc: "Voit vastaanottaa automaattiset tilitykset kun tuotteesi myydään.",
  payout_setup_desc: "Yhdistä pankkitilisi vastaanottaaksesi automaattiset tilitykset kun tuotteesi myydään. Ilman tätä kirpputori joutuu maksamaan sinulle manuaalisesti.",
  automatic_payouts: "Automaattiset tilitykset pankkitilillesi",
  fast_transfers: "Nopeat siirrot (1-2 arkipäivää)",
  secure_payments: "Turvallinen ja salattu",
  connect_bank_account: "Yhdistä pankkitili",
  multi_device: "Monilaite",
  multi_device_pos: "Monilaitekassa",
  multi_device_desc: "Käytä puhelintasi viivakoodinlukijana ja tämä näyttö näyttää ostoskorin",
  start_register: "Aloita kassana",
  register_desc: "Luo koodi puhelimen yhdistämiseksi",
  join_as_scanner: "Liity skannerina",
  scanner_desc: "Syötä koodi kassalaitteesta",
  scanner_mode: "Skanneritila",
  register_mode: "Kassatila",
  waiting_for_scans: "Odotetaan skannauksia",
  scanner_will_add: "Yhdistetyllä laitteella skannatut tuotteet näkyvät täällä",
  enter_session_code: "Syötä 6-merkkinen istuntokoodi",
  session_not_found: "Istuntoa ei löytynyt tai se on vanhentunut",
  item_added: "Tuote lisätty!",
  camera_permission_needed: "Kameran käyttöoikeus tarvitaan viivakoodien skannaamiseen",
  last: "Viimeisin",
  not_found: "Ei löytynyt",
  scan_barcode: "Skannaa viivakoodi",
  scan_customer_qr: "Skannaa asiakkaan QR-koodi",
  enter_product_id: "Syötä tuotetunnus tai viivakoodi",
  scan_to_add: "Skannaa tuotteita lisätäksesi koriin",
  sale_complete: "Myynti suoritettu!",
  already_in_cart: "Tämä tuote on jo korissa",
  info: "Tiedoksi",
  payment_method: "Maksutapa",
  card_external: "Kortti",
  stripe_terminal: "Stripe",
  charge_card: "Veloita kortti",
  processing_payment: "Käsitellään maksua",
  present_card: "Aseta kortti maksupäätteeseen...",
  manage_reservation: "Hallitse varausta",
  days_remaining: "päivää jäljellä",
  product_statistics: "Tuotetilastot",
  total_value: "Kokonaisarvo",
  sold_value: "Myyty arvo",
  payment_status: "Maksutila",
  pay_now: "Maksa nyt",
  actions: "Toiminnot",
  print_price_tags: "Tulosta hintalappuja",
  print_tags_desc: "Luo tulostettavat tarrat QR-koodeilla",
  share_products: "Jaa tuotteita",
  share_products_desc: "Hanki jaettava linkki tuotteisiisi",
  booth: "Myyntipiste",
  no_products_in_booth: "Ei tuotteita saatavilla tässä myyntipisteessä",
  export_csv: "Vie CSV-tiedostoon",
  export_csv_desc: "Lataa tuotelista taulukkona",
  danger_zone: "Vaaravyöhyke",
  cancel_reservation_desc: "Tämä poistaa tuotteiden linkityksen ja peruuttaa varauksen",
  cancel_error: "Varauksen peruutus epäonnistui",
  cancel_reservation_confirm: "Haluatko varmasti peruuttaa tämän varauksen? Kaikki linkitetyt tuotteet poistetaan.",
  export_error: "Tuotteiden vienti epäonnistui",
  csv_export_web_only: "CSV-vienti on saatavilla vain verkossa",
  check_out_my_products: "Tutustu tuotteisiini",
  link_copied: "Linkki kopioitu leikepöydälle!",
  map_not_available: "Karttanäkymä on saatavilla vain verkossa",
  switch_to_list: "Vaihda listanäkymään",
  your_location: "Sijaintisi",
  view_store: "Näytä kauppa",
  actual_count: "Todellinen määrä",
  adjust: "Säädä",
  adjustment_hint: "Kirjoita muutoksen syy",
  adjustment_type: "Muutostyyppi",
  adjust_stock: "Säädä varastoa",
  current_stock: "Nykyinen varasto",
  in_stock: "Varastossa",
  low: "Vähissä",
  low_stock_hint: "Hälytä kun varasto laskee alle tämän",
  negative_stock: "Negatiivinen varasto",
  quantity_change: "Määrän muutos",
  reorder_hint: "Tilaa automaattisesti tällä tasolla",
  save_adjustment: "Tallenna muutos",
  stock_adjustment: "Varastosäätö",
  stock_updated: "Varasto päivitetty",
  count_hint: "Syötä laskettu todellinen määrä",
  categories: "Kategoriat",
  category: "Kategoria",
  category_has_children: "Kategorialla on alakategorioita",
  category_has_products: "Kategoriassa on tuotteita",
  category_id: "Kategoria-ID",
  delete_category_confirm: "Haluatko varmasti poistaa tämän kategorian?",
  new_category: "Uusi kategoria",
  no_categories: "Ei kategorioita",
  no_category: "Ei kategoriaa",
  parent_category: "Yläkategoria",
  select_category: "Valitse kategoria",
  select_parent: "Valitse yläkategoria",
  subcategories: "Alakategoriat",
  no_parent: "Ei yläkategoriaa",
  add_category_hint: "Lisää kategoria tuotteiden järjestämiseksi",
  add_item: "Lisää tuote",
  add_items: "Lisää tuotteita",
  add_product: "Lisää tuote",
  condition: "Kunto",
  condition_new: "Uusi",
  condition_like_new: "Kuin uusi",
  condition_good: "Hyvä",
  condition_fair: "Kohtalainen",
  condition_poor: "Huono",
  min_price: "Min €",
  max_price: "Max €",
  condition_notes: "Kuntomerkinnät",
  condition_notes_placeholder: "Kuvaile kulumaa, vaurioita tai vikoja",
  cost_price: "Hankintahinta",
  cost_price_hint: "Ostohintasi katteen laskentaan",
  current_margin: "Nykyinen kate",
  damage_hint: "Merkitse vauriot tai viat",
  draft_products: "Luonnostuotteet",
  minimum_price: "Minimihinta",
  minimum_price_hint: "Alin hyväksyttävä hinta",
  no_draft_products: "Ei luonnostuotteita",
  no_products_in_store: "Ei tuotteita tässä kaupassa",
  no_products_to_print: "Ei tulostettavia tuotteita",
  no_store_products: "Ei kaupan tuotteita",
  ownership_type: "Omistustyyppi",
  price: "Hinta",
  product: "tuote",
  product_id: "Tuote-ID",
  publish: "Julkaise",
  select_condition: "Valitse kunto",
  select_product: "Valitse tuote",
  selling_price: "Myyntihinta",
  target_margin: "Tavoitekate",
  create_po_hint: "Luo ostotilaus seurataksesi saapuvaa varastoa",
  expected: "Odotettu",
  expected_delivery: "Odotettu toimitus",
  new_order: "Uusi tilaus",
  no_orders_in_status: "Ei tilauksia tässä tilassa",
  no_purchase_orders: "Ei ostotilauksia",
  order_date: "Tilauspäivä",
  order_info: "Tilaustiedot",
  order_notes_placeholder: "Lisää huomioita tilauksesta",
  order_received: "Tilaus vastaanotettu",
  order_saved: "Tilaus tallennettu",
  purchase_order_id: "Ostotilaus-ID",
  purchase_orders: "Ostotilaukset",
  receive_order: "Vastaanota tilaus",
  receive_order_confirm: "Merkitäänkö tilaus vastaanotetuksi?",
  sent: "Lähetetty",
  shipped: "Toimitettu",
  unit_cost: "Yksikköhinta",
  quantity_returned: "Palautettu määrä",
  return_hint: "Syötä palautettava määrä",
  enter_supplier_name: "Syötä toimittajan nimi",
  no_supplier: "Ei toimittajaa",
  select_supplier: "Valitse toimittaja",
  supplier_code: "Toimittajakoodi",
  supplier_id: "Toimittaja-ID",
  already_paid: "Jo maksettu",
  automatic_transfers: "Automaattiset siirrot",
  charges_enabled: "Veloitukset käytössä",
  checkout: "Kassa",
  complete_setup: "Viimeistele asetukset",
  complete_stripe_setup: "Viimeistele Stripe-asetukset",
  connect_stripe: "Yhdistä Stripe",
  details_submitted: "Tiedot lähetetty",
  not_connected: "Ei yhdistetty",
  open_stripe_dashboard: "Avaa Stripe-hallintapaneeli",
  pay: "Maksa",
  payment: "Maksu",
  payment_not_ready: "Maksu ei ole valmis",
  payment_received: "Maksu vastaanotettu",
  payment_successful: "Maksu onnistui",
  payments: "Maksut",
  payments_desc: "Hallitse maksuasetuksiasi",
  payouts_enabled: "Tilitykset käytössä",
  proceed_to_payment: "Siirry maksamaan",
  receipt_emailed: "Kuitti lähetetään sähköpostilla",
  receipt_in_app: "Kuitti näkyy sovelluksessa",
  receive_payments: "Vastaanota maksuja",
  secure_payment: "Turvallinen maksu",
  stripe_connect_account_id: "Stripe-tili-ID",
  stripe_connect_explanation: "Yhdistä Stripe-tilisi vastaanottaaksesi maksuja",
  stripe_not_loaded: "Maksujärjestelmää ei ladattu",
  subtotal: "Välisumma",
  tax: "Vero",
  terminal_support: "Päätteen tuki",
  totals: "Yhteensä",
  enter_market_name: "Syötä kirpputorin nimi",
  flea_market_id: "Kirpputori-ID",
  market: "Kirpputori",
  no_space: "Ei tilaa saatavilla",
  space: "Tila",
  click_to_place: "Klikkaa sijoittaaksesi",
  confirm_delete_element: "Poistetaanko tämä elementti?",
  delete_element: "Poista elementti",
  element_details: "Elementin tiedot",
  wall: "Seinä",
  window: "Ikkuna",
  thickness: "Paksuus",
  print: "Tulosta",
  print_tags: "Tulosta tarrat",
  print_tags_hint: "Tulosta hintalaput tuotteille",
  tag_size: "Tarran koko",
  address: "Osoite",
  address_placeholder: "Syötä osoite",
  description_en: "Kuvaus (englanti)",
  description_fi: "Kuvaus (suomi)",
  enter_name: "Syötä nimi",
  name_en: "Nimi (englanti)",
  name_fi: "Nimi (suomi)",
  name_required: "Nimi vaaditaan",
  title_en: "Otsikko (englanti)",
  title_fi: "Otsikko (suomi)",
  title_required: "Otsikko vaaditaan",
  preferred_language: "Ensisijainen kieli",
  after: "Jälkeen",
  before: "Ennen",
  dates: "Päivämäärät",
  end: "Loppu",
  period: "Jakso",
  start_point: "Alku",
  auto_generated: "Automaattisesti luotu",
  cannot_delete: "Ei voi poistaa",
  create_failed: "Luonti epäonnistui",
  delete_failed: "Poisto epäonnistui",
  details: "Tiedot",
  done: "Valmis",
  no_change: "Ei muutoksia",
  no_icon: "Ei kuvaketta",
  no_items: "Ei kohteita",
  qty: "Kpl",
  reason: "Syy",
  reason_placeholder: "Syötä syy",
  reservation_summary: "Varauksen yhteenveto",
  save_failed: "Tallennus epäonnistui",
  save_send: "Tallenna ja lähetä",
  select_icon: "Valitse kuvake",
  shipping: "Toimitus",
  thank_you: "Kiitos!",
  tap_to_apply: "Napauta käyttääksesi",
  tap_to_change: "Napauta vaihtaaksesi",
  failed_to_pick_images: "Kuvien valinta epäonnistui",
  gallery_permission_message: "Tarvitsemme pääsyn kuviisi lisätäksemme tuotekuvia",
  permission_required: "Lupa vaaditaan",
  depth_cm: "Syvyys (cm)",
  width_cm: "Leveys (cm)",
  pos_hint: "Käytä kassaa tapahtumien käsittelyyn",
  dropoff_info: "Tuontiohjeet",
  dropoff_info_placeholder: "Milloin ja minne myyjät voivat tuoda hyväksytyt tavarat?",
  sell_myself_at_market: "Haluan itse myydä kirpputorilla",
  sell_myself_at_market_desc: "Varaa pöytä ja myy tuotteesi itse paikan päällä",
  sell_on_my_behalf: "Haluan että puolestani myydään",
  sell_on_my_behalf_desc: "Jätä tuotteet kirpputorille ja henkilökunta hoitaa myynnin",
  sell_immediately: "Haluan myydä heti",
  sell_immediately_desc: "Tarjoa tavaroitasi kaupoille jotka ostavat ne heti",
  full_service: "Täyden palvelun kirpputori",
  no_fullservice_markets: "Ei täyden palvelun kirpputoreja alueellasi vielä",
  services_section_desc: "Valitse tarjoamasi myyntitavat. Voit ottaa käyttöön minkä tahansa yhdistelmän.",
  self_service_mode: "Itsemyynti",
  self_service_mode_desc: "Myyjät varaavat paikan ja myyvät tuotteensa itse",
  full_service_mode: "Puolestamyynti",
  full_service_mode_desc: "Henkilökunta hoitaa myynnin myyjän puolesta",
  full_service_info: "Puolestamyynnin ohjeet",
  full_service_info_placeholder: "Esim. tuotteiden tuonti, provisio, maksuehdot...",
  direct_purchase_mode: "Suoraosto",
  direct_purchase_mode_desc: "Osta tuotteita suoraan myyjiltä",
  stores_accepting_offers: "Tarjouksia vastaanottavat kaupat",
  no_stores_accepting_offers: "Ei vielä tarjouksia vastaanottavia kauppoja alueellasi",
  submit_offer: "Lähetä tarjous",
  offer_description: "Kuvaus",
  offer_description_placeholder: "Kuvaile tuotetta...",
  offer_price: "Hintapyyntösi",
  item_photos: "Kuvat",
  add_photos: "Lisää kuvia",
  max_photos: "Max 5 kuvaa per tuote",
  notes_to_store: "Viesti kaupalle",
  notes_to_store_placeholder: "Lisätietoja...",
  submit: "Lähetä",
  submitting: "Lähetetään...",
  offer_submitted: "Tarjous lähetetty! Kauppa käsittelee sen pian.",
  add_at_least_one_item: "Lisää vähintään yksi tuote",
  enter_item_price: "Syötä hinta kaikille tuotteille",
  my_offers: "Omat tarjoukset",
  offer_pending: "Odottaa vastausta",
  offer_accepted: "Hyväksytty",
  offer_rejected: "Hylätty",
  offer_completed: "Valmis",
  no_offers_yet: "Ei vielä tarjouksia",
  no_offers_description: "Lähetetyt tarjouksesi näkyvät täällä.",
  offer_details: "Tarjouksen tiedot",
  store_response: "Kaupan viesti",
  responded: "Vastattu",
  your_notes: "Omat muistiinpanot",
  incoming_offers: "Saapuneet tarjoukset",
  no_pending_offers: "Ei odottavia tarjouksia",
  no_accepted_offers: "Ei hyväksyttyjä tarjouksia",
  no_rejected_offers: "Ei hylättyjä tarjouksia",
  no_completed_offers: "Ei valmiita tarjouksia",
  seller_notes: "Myyjän viesti",
  your_response: "Sinun viestisi",
  accept: "Hyväksy",
  accept_offer: "Hyväksy tarjous",
  reject_offer: "Hylkää tarjous",
  message_to_seller: "Viesti myyjälle",
  accept_message_placeholder: "Esim. Kiitos tarjouksesta! Tuontiajat löytyvät ohjeista.",
  reject_message_placeholder: "Esim. Emme valitettavasti pysty vastaanottamaan näitä tuotteita.",
  offer_accepted_message: "Tarjous hyväksytty",
  offer_rejected_message: "Tarjous hylätty",
  mark_completed_confirm: "Haluatko merkitä tarjouksen valmiiksi?",
  try_again: "Yritä uudelleen",
  refunds: "Hyvitykset",
  issue_refund: "Tee hyvitys",
  process_refund: "Käsittele hyvitys",
  refund_reason: "Hyvityksen syy",
  refund_total: "Hyvitys yhteensä",
  refund_confirmation: "Hyvityksen vahvistus",
  refund_processed: "Hyvitys käsitelty onnistuneesti",
  confirm_refund: "Vahvista hyvitys",
  enter_reason: "Syötä syy",
  fully_refunded: "Kokonaan hyvitetty",
  no_items_to_refund: "Ei hyvitettäviä tuotteita",
  cash_refund_manual: "Käteishyvitys - käsittele manuaalisesti",
  select_items_to_refund: "Valitse hyvitettävät tuotteet",
  connected: "Yhdistetty",
  connect_reader: "Yhdistä lukija",
  creating_payment: "Luodaan maksua...",
  no_reader_connected: "Ei yhdistettyä lukijaa",
  no_readers_found: "Lukijoita ei löytynyt",
  payment_cancelled: "Maksu peruutettu",
  reader_connected: "Lukija yhdistetty",
  reader_disconnected: "Lukija irrotettu",
  refresh_readers: "Päivitä lukijat",
  select_reader: "Valitse lukija",
  terminal_not_ready: "Maksupääte ei valmis",
  accepted: "Hyväksytty",
  items_to_offer: "Tarjottavat tuotteet",
  offer_submit_failed: "Tarjouksen lähetys epäonnistui",
  offer_to: "Tarjoa kohteeseen",
  select_products: "Valitse tuotteet",
  select_products_hint: "Valitse tuotteet joita haluat tarjota kauppaan",
  no_products_to_offer: "Ei tarjottavia tuotteita",
  add_products_first_offer: "Lisää ensin tuotteita kameralla tai galleriasta, sitten voit tarjota niitä kaupoille.",
  your_price: "Hintapyyntösi",
  selected_products: "Valitut tuotteet",
  pcs: "kpl",
  offers: "Tarjoukset",
  add_another_item: "Lisää toinen tuote",
  add_item_photos: "Lisää tuotekuvia",
  add_photo: "Lisää kuva",
  additional_notes: "Lisätiedot",
  enter_item_title: "Syötä tuotteen nimi",
  enter_valid_price: "Syötä kelvollinen hinta",
  expected_price: "Toivottu hinta",
  item: "Tuote",
  item_description_placeholder: "Kuvaile tuotteen kunto, merkki jne.",
  item_title_placeholder: "Esim. Siniset Nike lenkkarit koko 42",
  new_product: "Uusi tuote",
  photos: "Kuvat",
  suggested_price: "Ehdotettu hinta",
  find_market: "Etsi kirpputori",
  from: "Alkaen",
  map_web_only: "Kartta on käytettävissä vain verkkoselaimessa",
  no_markets_found: "Kirpputoreja ei löytynyt",
  no_products_found: "Tuotteita ei löytynyt",
  no_sales_found: "Myyntejä ei löytynyt",
  sales: "Myynnit",
  search_sales: "Hae myyntejä",
  show_list: "Näytä lista",
  show_map: "Näytä kartta",
  check_back_later: "Tarkista myöhemmin",
  no_spots_available: "Ei vapaita paikkoja",
  store_not_found: "Kauppaa ei löytynyt",
  access_denied: "Pääsy estetty",
  click_end_point: "Klikkaa seinän loppupiste",
  click_start_point: "Klikkaa seinän alkupiste",
  edit_category: "Muokkaa kategoriaa",
  icon: "Ikoni",
  length: "Pituus",
  line_total: "Rivin summa",
  no_name: "Ei nimeä",
  reports: "Raportit",
  revenue: "Liikevaihto",
  services: "Palvelut",
  today: "Tänään",
  door: "Ovi",
  pillar: "Pilari",
  stairs: "Portaat",
  elevator: "Hissi",
  wc: "WC",
  sink: "Pesuallas",
  electrical_outlet: "Pistorasia",
  fire_exit: "Hätäuloskäynti",
  entrance: "Sisäänkäynti",
  counter: "Kassa/Tiski",
  storage: "Varasto",
  table: "Pöytä",
  large_table: "Iso pöytä",
  rack: "Rekki",
  shelf: "Hylly",
  second_hand: "Käytetyt tavarat",
  collections: "Kokoelmat",
  all_items: "Kaikki tuotteet",
  uncategorized: "Luokittelemattomat",
  create_collection: "Luo kokoelma",
  edit_collection: "Muokkaa kokoelmaa",
  delete_collection: "Poista kokoelma",
  collection_name: "Kokoelman nimi",
  collection_name_placeholder: "Esim. Kesävaatteet, Elektroniikka...",
  collection_color: "Väri",
  move_to_collection: "Siirrä kokoelmaan",
  remove_from_collection: "Poista kokoelmasta",
  no_collections: "Ei kokoelmia vielä",
  create_first_collection: "Luo ensimmäinen kokoelma järjestääksesi tuotteita",
  collection_created: "Kokoelma luotu",
  collection_updated: "Kokoelma päivitetty",
  collection_deleted: "Kokoelma poistettu",
  items_moved: "Tuotteet siirretty kokoelmaan",
  confirm_delete_collection: "Poista kokoelma? Tuotteet siirretään luokittelemattomiin.",
  select_collection: "Valitse kokoelma",
  offer_entire_collection: "Tarjoa koko kokoelma",
  search_products_or_stores: "Etsi tuotteita tai kauppoja...",
  finds_for_you: "Löytöjä sinulle",
  stores_near_you: "Kaupat läheltäsi",
  show_less: "Näytä vähemmän",
  how_fliisi_works: "Miten Fliisi toimii",
  browse_products_online: "Selaa tuotteita verkossa",
  find_nearest_stores: "Löydä lähimmät kaupat",
  buy_from_stores: "Osta myymälöistä",
  user_default: "Käyttäjä",
  sign_in_full: "Kirjaudu sisään",
  sign_in_for_qr: "Kirjaudu sisään näyttääksesi QR-koodin",
  show_at_checkout: "Näytä kassalla",
  qr_receipt_hint: "Kassahenkilö skannaa koodin liittääkseen ostoksen profiiliisi",
  save_favorites_track_purchases: "Tallenna suosikit ja seuraa ostoksia",
  create_account: "Luo tili",
  my_purchases: "Omat ostokset",
  about_fliisi: "Tietoa Fliisistä",
  fliisi_description: "Fliisi yhdistää kirpputorit ja asiakkaat. Selaa verkossa, osta myymälässä. Kestävää shoppailua helposti.",
  opening_gallery: "Avataan galleria...",
  products_that_interest_you: "Tuotteita jotka saattaisivat kiinnostaa sinua",
  no_purchases_yet: "Ei vielä ostoksia",
  purchases_empty_hint: "Kun ostat tuotteita ja myyjä yhdistää ostoksen tiliisi, ne näkyvät täällä.",
  purchase_count: "Ostokerta",
  voided: "Mitätöity",
  unnamed_product: "Nimetön tuote",
  unknown_product: "Tuntematon tuote",
  discount: "Alennus",
  yesterday: "Eilen",
  recent_searches: "Viimeisimmät haut",
  popular_categories_label: "Suositut kategoriat",
  search_nearby: "Hae läheltäsi",
  find_stores_on_map: "Löydä kauppoja kartalta",
  search_products_stores: "Etsi tuotteita, kauppoja...",
  try_different_keywords: "Kokeile eri hakusanoja",
  results: "tulosta",
  no_results_found: "Ei tuloksia",
  map_label: "Kartta",
  show_store: "Näytä kauppa",
  recent_drafts: "Viimeisimmät luonnokset",
  take_photo_to_start: "Ota kuva tuotteesta aloittaaksesi myymisen",
  products_awaiting_link: "tuotetta odottaa linkitystä",
  active_reservations_count: "aktiivista varausta",
  reserve_selling_spot: "Varaa myyntipaikka",
  manage_your_store: "Hallitse kauppaasi",
  transactions: "Tapahtumat",
  transaction_history: "Tapahtumahistoria",
  void_sale: "Mitätöi myynti",
  void_reason: "Syy",
  void_reason_hint: "Miksi tämä myynti mitätöidään?",
  confirm_void: "Vahvista mitätöinti",
  sale_voided: "Mitätöity",
  partial_return: "Palauta tuotteet",
  no_transactions: "Ei tapahtumia vielä",
  select_items_to_return: "Valitse palautettavat tuotteet",
  return_selected: "Palauta valitut",
  items_returned: "Tuotteet palautettu",
  sale_void_success: "Myynti mitätöity onnistuneesti",
  store_info: "Kaupan tiedot",
  hide_details: "Piilota",
  filters: "Suodattimet",

  // Email templates
  email_receipt_preview: "Kuitti {receiptNumber} — {storeName}",
  email_receipt_number: "Kuitti {receiptNumber}",
  email_receipt_total: "Yhteensä",
  email_receipt_payment_method: "Maksutapa",
  email_receipt_thanks: "Kiitos asioinnista!",
  email_receipt_via_fliisi: "Tämä kuitti on lähetetty Fliisin kautta.",
  email_payment_card: "Kortti",
  email_payment_cash: "Käteinen",
  email_payment_mobilepay: "MobilePay",
  email_invite_heading: "Kutsu myymälään",
  email_invite_body: "{inviterName} on kutsunut sinut myymälän {storeName} tiimiin roolilla {role}.",
  email_invite_accept: "Hyväksy kutsu",
  email_invite_ignore: "Jos et odottanut tätä kutsua, voit jättää tämän viestin huomiotta.",
  email_role_cashier: "kassatyöntekijä",
  email_role_admin: "ylläpitäjä",
  email_role_super_admin: "pääkäyttäjä",
  email_unsubscribe: "Peruuta sähköpostitilaus",




} as const
